// The letter's section labels, in one client-safe place.
//
// The page renders the letter natively and the email renders it as html; if they
// each named their own sections, the two would drift the first time one was
// edited. They can't share `render.ts` — that pulls in the unsubscribe signer,
// which is node crypto and server-only — so the names live here on their own.

export const LETTER_LABELS = {
  can_do: 'what you can do now',
  smoothed: 'what got smoother',
  shipped: 'what shipped',
  wrote: 'what we wrote',
  said: 'said out loud',
} as const;
